<template>
  <input
    v-imask="mask"
    type="tel"
    class="smdt-input"
    :value="$props.context._value"
    @accept="onAccept"
  />
</template>

<script>
import { IMaskDirective } from 'vue-imask'

export default {
  name: 'PhoneInput',
  directives: {
    imask: IMaskDirective,
  },
  props: {
    context: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mask: {
        mask: '+33 \\00 00 00 00 00',
        lazy: false,
        placeholderChar: 'x',
      },
    }
  },
  methods: {
    onAccept(e) {
      this.$props.context.node.input(e.detail.value)
    },
  },
}
</script>

<style scoped lang="scss"></style>
